import { observer } from 'mobx-react';
import * as React from 'react';
import { BsArrowRepeat } from '@react-icons/all-files/bs/BsArrowRepeat';

export interface ILoaderProps {
    readonly message?: string;
    readonly showSpinner?: boolean;
    readonly center?: boolean;
    readonly className?: string;
    readonly loading: boolean;
}

@observer
export class Loader extends React.Component<ILoaderProps> {
    public render() {
        const { loading, center, showSpinner, message, className, children } = this.props;

        if (!loading) return null;

        return (
            <div className={`${className} ${center ? ' w-100 text-center' : ''}`}>
                {showSpinner && <BsArrowRepeat className="fa-spin" />}
                {children}
                {showSpinner && message && ' '}
                {message && <span>{message}</span>}
            </div>
        );
    }
}
